import { MUI } from 'components'

import { AlertCircle } from 'react-feather'

const PermissionsBox = () => {
  const permissionTexts = [
    'Acessar informações básicas da loja',
    'Coletar os dados de contato da loja',
    'Coletar os dados de endereço da loja',
    'Inserir popups e scripts no site da loja',
  ]

  return (
    <MUI.Box mb={6}>
      {permissionTexts.map((text) => (
        <MUI.Box display="flex" flexDirection="column" mt={1}>
          <MUI.Box display="flex" alignItems="center" gap={2}>
            <AlertCircle size={24} stroke="currentColor" />
            <MUI.Typography variant="body2">{text}</MUI.Typography>
          </MUI.Box>
        </MUI.Box>
      ))}
    </MUI.Box>
  )
}

export default PermissionsBox
